import React from 'react';
import Sidebar from '../Layout/Sidebar';
import Header from '../Layout/Header';
import FAQSection from '../components/FAQSection';
import HeroBanner from '../components/HeroBanner';
import iconFaq from '../assets/images/siteImg/icon-faq.svg';
import config from '../config';
import '../assets/css/learningMaterialStyles.css';
import { FooterMobile } from '../Layout/FooterMobile';
import { useOverviewContext } from '../context/OverviewContext';
import imgBanner from "../assets/images/banners/bannerImage_LearningMaterial.png";
import imgUnbox from "../assets/images/siteImg/learning-material/Image_Unbox.png";
import imgFaq1 from "../assets/images/siteImg/learning-material/Icon_FAQ_1.svg";
import imgFaq2 from "../assets/images/siteImg/learning-material/Icon_FAQ_2.svg";
import imgFaq3 from "../assets/images/siteImg/learning-material/Icon_FAQ_3.svg";
import imgFaq4 from "../assets/images/siteImg/learning-material/Icon_FAQ_4.svg";
// import styles from '../assets/css/learningMaterialStyles.module.css';

const LearningMaterial: React.FC = () => {
    const { HOME } = config.app.routes;
    // schoolType Lowercase handled from service
    const { schoolType } = useOverviewContext(); 
    console.log(schoolType);
    const learningMaterialFAQs = [
        {
          question: 'How soon can we expect to receive materials?',
          answer: "Materials are automatically shipped once a student has been assigned courses through their K12-powered school, which usually occurs within a week after meeting with a placement coordinator. You'll hear from a placement coordinator soon after enrollment is complete. Depending on grade and course level, your school may need to complete a transcript analysis. Materials will be delivered within four to seven business days after they ship.",
          icon: imgFaq1
        },
        {
          question: "What if our learning materials don't arrive before school starts?",
          answer: 'Your school is aware of the timing of course placement and will accommodate a delay in accessing supplies. Students can access online course content from a personal or public computer, such as at a public library, while waiting for learning materials.',
          icon: imgFaq2
        },
        {
          question: 'What school supplies do we need to provide?',
          answer: schoolType == "private"
                ? "K12 provides curriculum and special supplies required to complete the coursework. K12 does not supply printer ink and paper or basic items like notebooks, folders, and pens. Your teachers may have further suggestions for specific items you may wish to purchase to support learning"
                : "K12 provides curriculum and special supplies required to complete the coursework, often including a school computer for student use. K12 does not supply printer ink and paper or basic items like notebooks, folders, and pens. Your teachers may have further suggestions for specific items you may wish to purchase to support learning",            
          answer1: 'K12 provides curriculum and special supplies required to complete the coursework, often including a school computer for student use  . K12 does not supply printer ink and paper or basic items like notebooks, folders, and pens. Your teachers may have further suggestions for specific items you may wish to purchase to support learning.',
          icon: imgFaq3
        },
        {
          question: 'How many boxes of materials will we receive?',
          answer: 'Students will typically receive one box per course. Students in grades K–5 usually receive four to six boxes, which will be packed into one to two larger cartons for shipment and delivery. Students in grades 6–12 are assigned semester-long courses and will receive two shipments per year—one in the fall and one in January.',
          icon: imgFaq4
        },
    ];

    return (
    
        <div className="home-layout">
            <div className="sidebar-wrapper">
            <Sidebar />
            </div>
            <div className="body-wrapper-content">
            <div className="row">
                <div className="col-12">
                <Header />
                <main id="main" role="main">
                <div className="main-content">
                    <div className="row">
                        <div className="col-12">
                            <nav aria-label="breadcrumb" className="d-none d-sm-block">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href={HOME}>Home</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <span>Learning Materials</span>
                                    </li>
                                </ol>
                            </nav>
                        
                            
                        </div>
                    </div>

                    <HeroBanner
                        title="Learning Materials"
                        subtitle="Delight delivered to your door!"
                        imageUrl={imgBanner}
                        altText="Learning Materials"
                        customClass="bg-color-yellow-t1-supplies common-banner-bg-white"
                    />

                    <div className="wp-block-k12-section container-fluid bg-transparent">
                        <div className="row">
                            <div className="col-12 g-0">
                                <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                        <h2 className="wp-block-heading">Get Ready to Unbox a Great Education</h2>
                                        <p className="size-bigger">
                                            <strong>
                                                Your student learning materials
                                                {schoolType != "private" && "—a school computer,"} textbooks, supplies for offline activities, and more—are provided at no cost to your family.* 
                                            </strong>
                                        </p>
                                        <div style={{ height: '40px' }} aria-hidden="true" className="wp-block-spacer d-none d-lg-block" />
                                        
                                    </div>

                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '150px' }}>
                                        <figure className="wp-block-image size-full is-resized d-none d-xl-flex">
                                            <img
                                            decoding="async"
                                            width="336"
                                            height="304"
                                            src={imgUnbox}
                                            alt=""
                                            className="wp-image-415"
                                            style={{ width: '150px' }}
                                            />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 className="wp-block-heading">Learning Materials FAQs</h2>
                    <div style={{ height: '20px' }} aria-hidden="true" className="wp-block-spacer" />

                    <FAQSection faqsData={learningMaterialFAQs} />

                    <div style={{ height: '20px' }} className="wp-block-spacer" aria-hidden="true" />
                    <p className="size-smaller">
                        <em>
                            {schoolType !== "private" && "*Families do not pay tuition for a student to attend an online public school. "}
                            Materials provided vary by course, state, school, and grade level. Common household items and office supplies, like printer ink and paper, are not provided. Our enrollment consultants can help address your technology and computer questions and needs.
                        </em>
                    </p>

                </div>
                </main>
                </div>
            </div>
            </div>
            <FooterMobile />
        </div>
        
    );
};


export default LearningMaterial;